export default __webpack_public_path__ + "static/media/warning--wild-animals--g2.76bbe024.png";